<template>
  <v-card flat>
    <side-navigation-bar :show.sync="showSideNav" />
    <v-toolbar
      color="topBar"
      dark
      extended
      flat
    >
      <v-avatar 
        class="pa-1" 
        color="white"
        size="42"
        tile
      >
        <img src="../../assets/images/logo.png">
      </v-avatar>
      <v-app-bar-nav-icon 
        class="d-flex d-sm-none"
        @click.stop="showSideNav = !showSideNav" 
      />
      
      <v-spacer />
      <div class="px-2 d-none d-sm-flex">
        <v-btn
          text
          class="mr-2"
          :class="{'active': activeNavs().apps}"
          @click="$router.push('/apps')"
        >
          Apps
        </v-btn>
        <v-btn  
          text
          class="mr-2"
          :class="{'active': activeNavs().posServers}"
          @click="$router.push('/posServers')"
        >
          Pos Servers
        </v-btn>
        <v-btn
          text
          :class="{'active': activeNavs().pos}"
          class="pa-0 ma-0"
        >
          <pos-navigation />
        </v-btn>
        <v-btn
          text
          :class="{'active': activeNavs().event}"
          @click="$router.push('/eventAccounts')"
        >
          Event Accounts
        </v-btn>
        <v-btn
          text
          class="mr-2 "
          :class="{'active': activeNavs().inventory}"
          @click="$router.push('/inventory')"
        >
          Inventory
        </v-btn>
        <v-btn
          text
          :class="{'active': activeNavs().users}"
          class="pa-0 ma-0"
        >
          <user-navigation />
        </v-btn>
      </div>
      <v-divider vertical />
      <div class="pl-2">
        <logged-in-user />
      </div>
    </v-toolbar>

    <v-card
      class="mx-auto main-content"
      flat
    >
      <router-view :key="$route.path" />
    </v-card>
  </v-card>
</template>

<script>
import UserNavigation from "./UserNavigation.vue";
import LoggedInUser from "./LoggedInUser.vue";
import SideNavigationBar from "./NavigationBar.vue";
import PosNavigation from "./PosNavigation.vue";
export default {
	name: "Home",
  components: {
    UserNavigation,
    SideNavigationBar,
    LoggedInUser,
    PosNavigation
  },
	data() {
		return {
      showSideNav: false
		};
	},
  computed:{
    currentRoute(){
      return this.$router.currentRoute.name;
    }
  },
  methods: {
    activeNavs() {
      const routeName = this.$router.currentRoute.name;
      return {
        apps: routeName === "apps",
        posServers:routeName === "posServers",
        pos: routeName === "corporate"  || routeName === "accounts"  || routeName === "stores" || routeName === "loginMigration",
        event:routeName === "eventAccounts",
        inventory: routeName === "inventory",
        users: routeName === "users" || routeName === "roles"
      };
    }
  }
};
</script>
<style scoped>
.main-content {
  max-width:90%;
  margin-top: -50px;
}
</style>